export default {
	edit: 'Editar',
	delete: 'Excluir',
	enable: 'Ativar neste cenário',
	disable: 'Desativar neste cenário',
	next_step: 'Próximo passo',
	skip: 'Pular',
	finish_review: 'Concluir a revisão',
	skip_review: 'Pular a verificação',
	view: 'Ver detalhes',
	close: 'Fechar',
	cancel: 'Cancelar',
	send: 'Enviar',
	clone: 'Clonar',
	open: 'Abrir',
	sign_out: 'Sair',
	search: 'Pesquisar',
	save: 'Salvar',
	sort_by_name: 'Ordenar por nome (A→Z)',
	sort_by_importance: 'Ordenar por importância (alto→baixo)',
	filter_positive: 'Filtrar partes interessadas positivas',
	filter_negative: 'Filtrar partes interessadas negativas',
	export: {
		excel: 'Exportar como Excel',
		image: 'Exportar visualização como imagem'
	},
	click_to_select: 'Clique para selecionar',
	click_to_drag: 'Arraste para mover',
	confirm_drop: {
		message_baseline:
			'Você está atualizando a linha de base. Confirma as alterações?',
		message_scenario:
			'Você está atualizando o cenário {{scenarioName}}. Confirma as alterações?',
		likelihood: 'Probabilidade',
		impact: 'Impacto',
		before: 'Antes',
		after: 'Depois'
	}
};
